// 推廣歸因參數（ac / fc / pix / ttpix / kpix）的進站擷取 —— TI-15642 / JT-1785738540。
// 規格：spec/JT-1785738540_referral-param-persistence-fallback.md
//
// ⚠️ 檔名編號 00 不可調動：本檔是全專案第一支 plugin，擷取與雙寫必須在任何 await / API 之前
//    同步完成（原則 4），才能保證「導頁前已落地」。
import { captureReferralParams } from '@/utils/referral'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { setToken } = useAuthToken()

  // 三層解析（網址 → localStorage → cookie）後雙寫回兩個媒介：
  // 網址有值即 last-click 覆寫；網址無值則把既有副本原值寫回，形成 7 天滑動視窗。
  captureReferralParams(window.location.search)

  // SPA 導航補撿：已開啟的 PWA 殼接到 deep link 時不會重跑 plugin init
  useRouter().afterEach((to) => {
    captureReferralParams(to.fullPath)
  })

  const token = route.query.x
  if (token) {
    setToken(token)
  }
})
